// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"0dbf9530","388":"17c7246d","398":"e62ce3d1","521":"fa95cfb2","525":"bc447627","676":"362fb52f","759":"6b31de8b","800":"88aca343","845":"0d2fc13a"}[chunkId] + ".chunk.js";
};